
import { Breadcrumbs, CommonMultiSelect, CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import ErrorComponent from "components/shared/ErrorComponent";
import AppInputField from "components/shared/FormComponents/AppInputField";
import AppProfilePictureField from "components/shared/FormComponents/AppProfilePictureField";
import LoadingButton from "components/shared/LoadingButton";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { genericFormErrorMsg } from "utils/validation/validationHelpers";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

import styles from './profile.module.scss';
import { FieldArray, Formik } from "formik";
import { CLIENT_TYPES, MIME_TYPES, SUPPORT_STAFF_STATUS_EDIT_OPTION, SUPPORT_STAFF_STATUS_OPTION, TIMEZONE_OPTIONS } from "config/constants";
import AppSelectField from "components/shared/FormComponents/AppSelectField";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import { cloneDeep, debounce, isEmpty } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useCheckUsernameMutation, useGetProfileQuery, useUpdateProfileMutation } from "store/services/auth";
import { EditIcon } from "Assets/icons";
import UpdateEmailPop from "components/Modals/UpdateEmailPop";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { errorMessageToast, successMessageToast } from "helpers/common";
import { useGetSchoolDivisonListQuery, useLazyGetFileUrlQuery } from "store/services/utility";
import AppInputFieldV2 from "components/Common/AppInputFIeldV2";
import { CrossIcon } from "Assets/icons/v2";
import { SUPPORT_STAFF } from "config/paths";
import { useNavigate, useParams } from "react-router-dom";
import { useCreateSupportStaffMutation, useUpdateSupportStaffMutation, useViewSupportStaffQuery } from "store/services/V2/supportStaff";
import supportStaffAddSchema from "./supportStaff.schema";

const SupportStaffAdd = () => {
    const Navigate = useNavigate()
    const { id } = useParams()

    const [isEdit, setIsEdit] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(false);

    const {
        data: supportStaff,
        isLoading: supportStaffLoading,
        isError: supportStaffError,
        isFetching: supportStaffFetching
    } = useViewSupportStaffQuery({ id }, { skip: !id });

    const { data: schoolDivisionsList, isLoading: schoolDivisionsListLoading } = useGetSchoolDivisonListQuery();
    const [CreateSupporStaff, { isLoading: createStaffLoading }] = useCreateSupportStaffMutation()
    const [UpdateSupportStaff, { isLoading: updateSupportLoading }] = useUpdateSupportStaffMutation()

    useEffect(() => {
        if (id) {
            setIsEdit(true)
        }
    }, [id])

    const initialValues = useMemo(() => {

        return {
            firstname: supportStaff?.firstname || "",
            lastname: supportStaff?.lastname || "",
            email: supportStaff?.email || "",
            phone: supportStaff?.phone || "",
            status: SUPPORT_STAFF_STATUS_EDIT_OPTION.find(
                (item) => item.value === supportStaff?.status
            ),
            assign_schools: supportStaff?.school_support_staff?.map((item) => ({
                division: item.divisions
                    ? { value: item.divisions.id, label: item.divisions.title }
                    : null,

                name: item.schools
                    ? { value: item.schools.id, label: item.schools.name }
                    : null,
            })) || [{ division: null, name: null }]
        }
    }, [supportStaff]);

    const handleSubmit = async (payload) => {
        try {
            const values = cloneDeep(payload);
            const finalPayload = {
                firstname: values.firstname,
                lastname: values.lastname,
                phone: values.phone,
                email: values.email,
                profile_picture: "",
                isLoginAllowed: "active",
                status: values?.status?.value || "active",
                assign_schools: values.assign_schools
                    ?.filter(
                        (item) => item?.division?.value && item?.name?.value
                    )
                    .map((item) => ({
                        school_division_id: item.division.value,
                        school_id: item.name.value,
                    })) || [],
            };


            const result = isEdit ? await UpdateSupportStaff({ values: finalPayload, id }).unwrap() : await CreateSupporStaff(finalPayload).unwrap();
            if (result.error) return;
            if (result.status === "success") {
                successMessageToast(result?.message);
                Navigate(SUPPORT_STAFF)
            }
        } catch (err) { console.log("Error updating profile", err); }
    };


    return (
        <>
            <div className="px-3 py-2">
                <Breadcrumbs items={[{ label: "User", path: "/client/support-staff" }, { label: `${isEdit ? 'Edit Support Staff' : 'Add Support Staff'}`, path: "" }]} style={{ fontSize: "14px" }} />

                <UpdateEmailPop
                    confirmation={showEmailModal}
                    setConfirmation={setShowEmailModal}
                />
                <section className={`${styles.addForm} position-relative col-lg-10 addForm`}>
                    <Container fluid={true}>
                        {(supportStaffLoading) ? <LoadingIndicator /> : <Row>
                            {(supportStaffFetching) && <LoadingOverlay />}

                            <Col lg="12" className="my-2 px-0 ">
                                {supportStaffError ? (
                                    <ErrorComponent />
                                ) : (
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={supportStaffAddSchema}
                                        onSubmit={handleSubmit}
                                        enableReinitialize
                                    >
                                        {({
                                            handleSubmit,
                                            errors,
                                            submitCount,
                                            values,
                                            setFieldValue,
                                            setFieldError
                                        }) => (
                                            <Form onSubmit={handleSubmit}>
                                                <div
                                                >
                                                    {console.log('FORMIK VALUES', values)}

                                                    <Col lg="12" className="my-2">
                                                        <div className=' d-flex align-items-end justify-content-between'>
                                                            <h5 className='section-title-main fw-medium border-0 m-0 p-0'>
                                                                {isEdit ? 'Edit Support Staff' : 'Add Support Staff'}</h5>
                                                        </div>
                                                    </Col>

                                                    <div style={{ marginTop: "15px" }}>
                                                        <h5 className="section-title">1.   SUPPORT STAFF INFORMATION*</h5>
                                                        <div className="d-flex flex-column gap-4 pe-md-4">
                                                            <Row>
                                                                <Col md="6" className="d-flex gap-4">
                                                                    <div>
                                                                        <label className="discharge-screen-label">Last Name*</label>
                                                                        <AppInputFieldV2
                                                                            name="lastname"
                                                                            type="text"
                                                                            placeholder=""
                                                                            className={`readonly-box`}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className="discharge-screen-label">First Name*</label>
                                                                        <AppInputFieldV2
                                                                            name="firstname"
                                                                            type="text"
                                                                            placeholder=""
                                                                            className={`readonly-box`}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md="4">
                                                                    <label className="discharge-screen-label">Email*</label>
                                                                    <AppInputFieldV2
                                                                        name="email"
                                                                        type="email"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                    />
                                                                </Col>
                                                                <Col md="2">
                                                                    <label className="discharge-screen-label">Phone Number*</label>
                                                                    <AppInputFieldV2
                                                                        name="phone"
                                                                        type="text"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                    />
                                                                </Col>
                                                                {
                                                                    isEdit &&
                                                                    <Col md="3">
                                                                        <div className="reports-v2 mt-3 w-100 ">
                                                                            <label className="discharge-screen-label mb-0">Status</label>
                                                                            <CommonSelect
                                                                                // placeholder={"Select"}
                                                                                name="status"
                                                                                option={SUPPORT_STAFF_STATUS_EDIT_OPTION}
                                                                                // onChange={(e) => handleFilterChange("status")(e)} 
                                                                                isFilterV2
                                                                                styles={{
                                                                                    container: (provided) => ({
                                                                                        ...provided,
                                                                                        width: "100%", // ✅ Ensures the whole Select container is full width
                                                                                    }),
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                }
                                                            </Row>
                                                        </div>

                                                    </div>
                                                    <div style={{ marginTop: "36px" }}>
                                                        <h5 className="section-title">2.   ASSIGN SCHOOLS</h5>
                                                        <div  >
                                                            <FieldArray name="assign_schools" >
                                                                {({ push, remove }) => (
                                                                    <>
                                                                        {values.assign_schools?.map((_, index) => (
                                                                            <Row className="g-3 align-items-end reports-v2 my-1  classroom-conslutation" key={index}>
                                                                                <div className="d-flex gap-3 align-items-end">
                                                                                    <div className="w-100">
                                                                                        <label className="mb-1 fw-semibold" style={{ fontSize: "12px" }}>
                                                                                            School Division
                                                                                        </label>
                                                                                        <CommonSelect
                                                                                            placeholder=""
                                                                                            value={values.assign_schools[index].division}
                                                                                            option={
                                                                                                schoolDivisionsList?.length && schoolDivisionsList?.map(item => ({
                                                                                                    value: item.id,
                                                                                                    label: item.title,
                                                                                                }))
                                                                                            }
                                                                                            onChange={(val) => setFieldValue(`assign_schools[${index}].division`, val)}
                                                                                            isClearable
                                                                                            isFilterV2

                                                                                        />
                                                                                    </div>
                                                                                    <div className="w-100">
                                                                                        <label className="mb-1 fw-semibold" style={{ fontSize: "12px" }}>
                                                                                            School Name
                                                                                        </label>
                                                                                        <CommonSelect
                                                                                            placeholder=""
                                                                                            value={values.assign_schools[index].name}
                                                                                            onChange={(val) => setFieldValue(`assign_schools[${index}].name`, val)}
                                                                                            isClearable
                                                                                            isFilterV2
                                                                                            option={(() => {
                                                                                                const divisionId = values.assign_schools[index].division?.value;

                                                                                                if (!divisionId) return [];

                                                                                                const selectedSchoolIds = values?.assign_schools?.filter(
                                                                                                    (item) => item?.division?.value === divisionId
                                                                                                ).map((item) => item?.name?.value)

                                                                                                const divisionObj = schoolDivisionsList?.find(d => d.id === divisionId);

                                                                                                if (!divisionObj?.schools?.length) return [];

                                                                                                return cloneDeep(divisionObj.schools)
                                                                                                    .filter(
                                                                                                        (school) =>
                                                                                                            !selectedSchoolIds.includes(school.id)
                                                                                                    )
                                                                                                    .sort((a, b) => a.name.localeCompare(b.name))
                                                                                                    .map((school) => ({
                                                                                                        value: school.id,
                                                                                                        label: school.name,
                                                                                                    }));
                                                                                            })()}
                                                                                        />
                                                                                    </div>

                                                                                    <div style={{ width: "24px" }}>
                                                                                        {index > 0 ? (
                                                                                            <Button
                                                                                                onClick={() => remove(index)}
                                                                                                variant="link"
                                                                                                className="p-0 border-0 mb-2"
                                                                                            >
                                                                                                <CrossIcon classes="text-danger" />
                                                                                            </Button>
                                                                                        ) : null}
                                                                                    </div>

                                                                                </div>
                                                                            </Row>
                                                                        ))}
                                                                        <button className="button-filled mt-4" onClick={(e) => {
                                                                            e.preventDefault()
                                                                            push({ division: null, name: null })
                                                                        }} >Add Another</button>

                                                                    </>
                                                                )}
                                                            </FieldArray>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex justify-content-between mt-5">
                                                        <button onClick={() => Navigate(SUPPORT_STAFF)} className="button-outlined ">Cancel  </button>

                                                        <button className="button-filled ">{createStaffLoading || updateSupportLoading ? <LoadingIndicator color="#fff" /> : 'DONE'}  </button>
                                                    </div>


                                                </div>
                                                {(!isEmpty(errors) && submitCount > 0) && (
                                                    <Row className="mt-4">
                                                        <Col lg="12">
                                                            <span className="error">{genericFormErrorMsg}</span>
                                                        </Col>
                                                    </Row>
                                                )}
                                                {/* <Row className="mt-4">
                                                <Col className="my-2" lg="12">
                                                    <div
                                                        className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                                        style={{ borderTop: "1px solid #41a2a84d" }}
                                                    >
                                                        <LoadingButton
                                                            type="submit"
                                                            className="d-flex align-items-center justify-content-center commonBtn"
                                                            isLoading={updateProfileLoading}
                                                        >
                                                            Save
                                                        </LoadingButton>
                                                    </div>
                                                </Col>
                                            </Row> */}
                                            </Form>
                                        )}
                                    </Formik>
                                )}
                            </Col>

                        </Row>}
                    </Container>
                </section>
            </div>
        </>
    );
};

export default SupportStaffAdd;